import { render } from "./Tajam.vue?vue&type=template&id=9f9fca38"
import script from "./Tajam.vue?vue&type=script&lang=js"
export * from "./Tajam.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__